<template>
  <div class="scoreData-wrap">
    <div :class="`scoreData-bg  level-${levelKey}-bg`"></div>
    <div class="scoreData-content">
      <div class="scoreData-titile">APP 资产综合风险值</div>
      <div class="scoreData-data">
        <CountUp :startVal="0" :endVal="props.data" index="41" />
      </div>
      <div class="scoreData-level" :class="`level-${levelKey}`"></div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import CountUp from "@/components/common/countup.vue";
export default {
  components: {
    CountUp,
  },
  props: {
    data: Number,
    name: String
  },
  setup(props) {
    const levelKey = ref('safe');
    const getText = () => {
      switch (props.name) {
        case '安全':
          levelKey.value = 'safe';
          break;
        case '低风险':
          levelKey.value = 'low';
          break;
        case '中风险':
          levelKey.value = 'middle';
          break;
        case '高风险':
          levelKey.value = 'high';
          break;
        default:
          levelKey.value = 'safe';
          break;
      }
    };
    watch(props, () => {
      getText();
    });
    getText();

    return {
      props,
      levelKey
    };
  }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
  